// src/apolloClient.js
import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import Cookies from "js-cookie";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// HTTP Link
const httpLink = createHttpLink({
  uri: BACKEND_URL,
});

// Auth/Public Access Link
const authLink = setContext((request, { headers }) => {
  // If you only want public access:
  return {
    headers: {
      ...headers,
      "public-access": "true",
    },
  };
});

// Apollo Client without split, without wsLink
const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default client;
